// 數學測驗數據 - Mathematics Quiz Data
export const mathQuizData = [
  {
    id: 'algebra-quiz-1',
    title: '代數基礎測驗',
    description: '測試代數基本概念和運算',
    category: 'algebra',
    difficulty: 'beginner',
    timeLimit: 300, // 5 minutes
    totalQuestions: 10,
    questions: [
      {
        id: 'alg-q1',
        type: 'multiple-choice',
        question: '化簡 $2x + 3x$ 的結果是？',
        formula: '2x + 3x = ?',
        options: [
          { id: 'a', text: '$5x$', latex: '5x' },
          { id: 'b', text: '$6x$', latex: '6x' },
          { id: 'c', text: '$5x^2$', latex: '5x^2' },
          { id: 'd', text: '$6x^2$', latex: '6x^2' }
        ],
        correctAnswer: 'a',
        explanation: '同類項相加：$2x + 3x = (2+3)x = 5x$',
        points: 10
      },
      {
        id: 'alg-q2',
        type: 'multiple-choice',
        question: '展開 $(x + 2)^2$ 的結果是？',
        formula: '(x + 2)^2 = ?',
        options: [
          { id: 'a', text: '$x^2 + 4$', latex: 'x^2 + 4' },
          { id: 'b', text: '$x^2 + 2x + 4$', latex: 'x^2 + 2x + 4' },
          { id: 'c', text: '$x^2 + 4x + 4$', latex: 'x^2 + 4x + 4' },
          { id: 'd', text: '$x^2 + 4x + 2$', latex: 'x^2 + 4x + 2' }
        ],
        correctAnswer: 'c',
        explanation: '使用完全平方公式：$(x + 2)^2 = x^2 + 2(x)(2) + 2^2 = x^2 + 4x + 4$',
        points: 15
      },
      {
        id: 'alg-q3',
        type: 'multiple-choice',
        question: '因式分解 $x^2 - 4$ 的結果是？',
        formula: 'x^2 - 4 = ?',
        options: [
          { id: 'a', text: '$(x - 2)^2$', latex: '(x - 2)^2' },
          { id: 'b', text: '$(x + 2)^2$', latex: '(x + 2)^2' },
          { id: 'c', text: '$(x + 2)(x - 2)$', latex: '(x + 2)(x - 2)' },
          { id: 'd', text: '$(x - 4)(x + 1)$', latex: '(x - 4)(x + 1)' }
        ],
        correctAnswer: 'c',
        explanation: '使用平方差公式：$x^2 - 4 = x^2 - 2^2 = (x + 2)(x - 2)$',
        points: 15
      },
      {
        id: 'alg-q4',
        type: 'fill-in-blank',
        question: '解方程 $2x + 6 = 14$，$x = $ ____',
        formula: '2x + 6 = 14',
        correctAnswer: '4',
        explanation: '$2x = 14 - 6 = 8$，所以 $x = 4$',
        points: 10
      },
      {
        id: 'alg-q5',
        type: 'true-false',
        question: '$(-3)^2 = -9$ 是否正確？',
        formula: '(-3)^2 = -9',
        correctAnswer: false,
        explanation: '$(-3)^2 = (-3) \\times (-3) = 9$，不是 $-9$',
        points: 10
      }
    ]
  },
  {
    id: 'geometry-quiz-1',
    title: '幾何基礎測驗',
    description: '測試基本幾何概念和計算',
    category: 'geometry',
    difficulty: 'beginner',
    timeLimit: 400, // 6.67 minutes
    totalQuestions: 8,
    questions: [
      {
        id: 'geo-q1',
        type: 'multiple-choice',
        question: '三角形的內角和是多少度？',
        options: [
          { id: 'a', text: '90°' },
          { id: 'b', text: '180°' },
          { id: 'c', text: '270°' },
          { id: 'd', text: '360°' }
        ],
        correctAnswer: 'b',
        explanation: '三角形的內角和恆等於 $180°$',
        points: 10
      },
      {
        id: 'geo-q2',
        type: 'multiple-choice',
        question: '在直角三角形中，如果兩直角邊分別為3和4，斜邊長度是？',
        formula: 'a^2 + b^2 = c^2',
        options: [
          { id: 'a', text: '5' },
          { id: 'b', text: '6' },
          { id: 'c', text: '7' },
          { id: 'd', text: '8' }
        ],
        correctAnswer: 'a',
        explanation: '使用畢氏定理：$3^2 + 4^2 = 9 + 16 = 25 = 5^2$，所以斜邊長度為5',
        points: 15
      },
      {
        id: 'geo-q3',
        type: 'fill-in-blank',
        question: '圓的面積公式是 $A = $ ____',
        correctAnswer: 'πr²',
        explanation: '圓的面積公式是 $A = \\pi r^2$，其中 $r$ 是半徑',
        points: 10
      },
      {
        id: 'geo-q4',
        type: 'multiple-choice',
        question: '等腰三角形的兩個底角有什麼關係？',
        options: [
          { id: 'a', text: '相等' },
          { id: 'b', text: '互補' },
          { id: 'c', text: '互餘' },
          { id: 'd', text: '無關係' }
        ],
        correctAnswer: 'a',
        explanation: '等腰三角形的兩個底角相等',
        points: 10
      }
    ]
  },
  {
    id: 'trigonometry-quiz-1',
    title: '三角學基礎測驗',
    description: '測試三角函數基本概念',
    category: 'trigonometry',
    difficulty: 'intermediate',
    timeLimit: 450, // 7.5 minutes
    totalQuestions: 6,
    questions: [
      {
        id: 'trig-q1',
        type: 'multiple-choice',
        question: '$\\sin 30°$ 的值是？',
        formula: '\\sin 30° = ?',
        options: [
          { id: 'a', text: '$\\frac{1}{2}$', latex: '\\frac{1}{2}' },
          { id: 'b', text: '$\\frac{\\sqrt{2}}{2}$', latex: '\\frac{\\sqrt{2}}{2}' },
          { id: 'c', text: '$\\frac{\\sqrt{3}}{2}$', latex: '\\frac{\\sqrt{3}}{2}' },
          { id: 'd', text: '$1$', latex: '1' }
        ],
        correctAnswer: 'a',
        explanation: '$\\sin 30° = \\frac{1}{2}$ 是特殊角的三角函數值',
        points: 15
      },
      {
        id: 'trig-q2',
        type: 'multiple-choice',
        question: '畢氏恆等式是？',
        options: [
          { id: 'a', text: '$\\sin^2 \\theta + \\cos^2 \\theta = 1$', latex: '\\sin^2 \\theta + \\cos^2 \\theta = 1' },
          { id: 'b', text: '$\\sin \\theta + \\cos \\theta = 1$', latex: '\\sin \\theta + \\cos \\theta = 1' },
          { id: 'c', text: '$\\sin^2 \\theta - \\cos^2 \\theta = 1$', latex: '\\sin^2 \\theta - \\cos^2 \\theta = 1' },
          { id: 'd', text: '$\\sin \\theta \\cos \\theta = 1$', latex: '\\sin \\theta \\cos \\theta = 1' }
        ],
        correctAnswer: 'a',
        explanation: '畢氏恆等式：$\\sin^2 \\theta + \\cos^2 \\theta = 1$',
        points: 15
      },
      {
        id: 'trig-q3',
        type: 'true-false',
        question: '$\\cos 0° = 1$ 是否正確？',
        formula: '\\cos 0° = 1',
        correctAnswer: true,
        explanation: '$\\cos 0° = 1$ 是正確的',
        points: 10
      }
    ]
  },
  {
    id: 'percentage-quiz-1',
    title: '百分法測驗',
    description: '測試百分比計算能力',
    category: 'percentage',
    difficulty: 'beginner',
    timeLimit: 300, // 5 minutes
    totalQuestions: 8,
    questions: [
      {
        id: 'per-q1',
        type: 'multiple-choice',
        question: '將 $\\frac{3}{4}$ 轉換為百分比是？',
        formula: '\\frac{3}{4} = ?\\%',
        options: [
          { id: 'a', text: '75%' },
          { id: 'b', text: '34%' },
          { id: 'c', text: '43%' },
          { id: 'd', text: '30%' }
        ],
        correctAnswer: 'a',
        explanation: '$\\frac{3}{4} = 0.75 = 75\\%$',
        points: 10
      },
      {
        id: 'per-q2',
        type: 'multiple-choice',
        question: '某商品原價$100，打8折後的售價是？',
        options: [
          { id: 'a', text: '$80' },
          { id: 'b', text: '$92' },
          { id: 'c', text: '$108' },
          { id: 'd', text: '$120' }
        ],
        correctAnswer: 'a',
        explanation: '8折 = 80%，售價 = $100 × 0.8 = $80',
        points: 15
      },
      {
        id: 'per-q3',
        type: 'fill-in-blank',
        question: '如果一個班有40名學生，其中25名是男生，男生的百分比是 _____%',
        correctAnswer: '62.5',
        explanation: '男生百分比 = $\\frac{25}{40} \\times 100\\% = 62.5\\%$',
        points: 15
      }
    ]
  }
];

export const mathQuizCategories = [
  { id: 'all', name: '全部', color: 'bg-gray-500' },
  { id: 'algebra', name: '代數', color: 'bg-blue-500' },
  { id: 'geometry', name: '幾何', color: 'bg-green-500' },
  { id: 'trigonometry', name: '三角學', color: 'bg-red-500' },
  { id: 'percentage', name: '百分法', color: 'bg-yellow-500' },
  { id: 'statistics', name: '統計', color: 'bg-purple-500' }
];

export const mathQuizDifficulties = [
  { id: 'beginner', name: '初級', color: 'bg-green-500' },
  { id: 'intermediate', name: '中級', color: 'bg-yellow-500' },
  { id: 'advanced', name: '高級', color: 'bg-red-500' }
];

// Helper functions for quiz data
export const getQuizByTopicId = (topicId) => {
  return mathQuizData.find(quiz => quiz.id.includes(topicId.toLowerCase()));
};

export const getQuizzesByCategory = (category) => {
  return mathQuizData.filter(quiz => quiz.category === category);
};

export const getQuizDifficulty = (difficulty) => {
  return mathQuizData.filter(quiz => quiz.difficulty === difficulty);
};

export default mathQuizData; 